import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { inject } from '@angular/core';
import { AuthenticationService } from '../services/authentication.service';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, take } from 'rxjs/operators';
import {PermissionService} from "../services/permission.service";

export const adminRedirectGuard: CanActivateFn = (_route, _state): Observable<boolean | UrlTree> => {
  const authService = inject(AuthenticationService);
  const router = inject(Router);
  const permissionService = inject(PermissionService);

  return authService.loggedUser$.pipe(
    filter((user): user is NonNullable<typeof user> => !!user),
    take(1),
    map(user => {
      const canAccessCompanyDashboard = permissionService.canAccessDashboard();
      const canAccessUserDashboard = permissionService.canReadFavorite();

      let destination = '/auth/company-select';

      if (canAccessCompanyDashboard) {
        destination = '/app/dashboard-company';
      } else if (canAccessUserDashboard) {
        destination = '/app/dashboard-user';
      }

      return router.parseUrl(destination);
    }),
    catchError(() => of(router.parseUrl('/auth/company-select')))
  );
};
